import * as React from 'react'
import { TeamOutlined } from '@ant-design/icons'
import { List } from 'antd'
import { TTAvatar } from '../../shared/TTAvatar'
import { RuoloClienteModel } from '../../../models/UtenteModels'

interface ListClienteRoleProps {
    list: Array<RuoloClienteModel>
}

export const ListClienteRole: React.FC<ListClienteRoleProps> = (props) => {

    const renderDescription = (value: string) => {
        if (!value) return ""
        return value
    }

    let list = props.list == null ? [] : props.list
    debugger
    if (props.list != null && props.list.length==0)
        return (
            <h3>ATTENZIONE: E' necessario assegnare un Ruolo all'utente affinchè questo possa fare accesso</h3>
            )

    return (
        <List
            dataSource={list}
            rowKey={it => it.Id}
            pagination={false}
            renderItem={item => (
                <List.Item key={item.Id}>
                    <List.Item.Meta
                        avatar={<TTAvatar icon={<TeamOutlined />} />}
                        title={item.Ruolo}
                        description={renderDescription(item.Cliente)} />
                </List.Item>
            )} />
    )
}